import React from 'react';
import { formatEur } from '../../Utils/money';
import { Band, Stat } from './Band';
import { PeriodRange, monthsInRange } from './PeriodFilter';
import { BillingAlertsSummary } from './useBillingAlertsSummary';

const rangeNote = (range: PeriodRange, truncated: boolean): string => {
	const months = monthsInRange(range);
	const span =
		months.length === 1
			? `${months[0]} · 1 mois`
			: `${months[0]} → ${months[months.length - 1]} · ${months.length} mois`;
	// Un total partiel présenté comme complet vaut moins que pas de total.
	return truncated ? `${span} · totaux partiels` : span;
};

/** Tout ce qui est ici suit le filtre : ce sont des montants mesurés. */
export const RangeBand: React.FC<{
	summary: BillingAlertsSummary;
	range: PeriodRange;
}> = ({ summary, range }) => {
	const show = (value: number) => (summary.isLoading ? '—' : formatEur(value));

	// Ce que Quanti PAIE à Google, jamais ce que le client est facturé : le
	// montant facturé vit chez Stripe et n'a rien à faire sur cet écran, dont
	// tout le propos est la dépense.
	const stats: Stat[] = [
		{ value: show(summary.measuredEur), label: 'conso managée mesurée' },
		{
			value: show(summary.unpaidDwEur),
			label: 'conso des comptes sans abonnement actif',
			tone: 'critical',
		},
		{
			value: show(summary.orphanEur),
			label: 'conso orpheline, projet supprimé',
			tone: 'warn',
		},
		{ value: show(summary.storageEur), label: 'dont storage' },
	];

	return (
		<Band
			title="Conso mesurée sur la plage"
			note={rangeNote(range, summary.truncated)}
			stats={stats}
		/>
	);
};
